




















































































































































































































































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";
import HasValidation from "@/mixins/HasValidation";
import RequestPromises from "@/mixins/requestPromises";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { BrandConfigKeys } from "@/data/constants";
import { InvoiceConsolidationTypes } from "@/data/enums/invoice";

// Types
import { IState } from "@/store";
import {
  IContractProduct,
  IContractProductSettingsForm
} from "@/models/contracts";
import { IClientProviderData } from "@/models/providers/client";
import { IClient } from "@/models/clients";
import { Location } from "vue-router";

@Component({
  computed: {
    ...mapState({
      invoiceConsolidation(state: IState) {
        return state.brand.config[
          BrandConfigKeys.INVOICE_CONSOLIDATION_ENABLED
        ];
      }
    })
  },
  components: {
    "payment-method-vessel": () =>
      import("@/components/app/global/payments/paymentMethodVessel.vue"),
    "recurring-due-date-control": () =>
      import("@/components/app/global/invoices/recurringDueDateControl.vue"),
    "invoice-generation-control": () =>
      import("@/components/app/global/invoices/invoiceGenerationControl.vue"),
    "automation-intervals-control": () =>
      import(
        "@/components/app/global/client/contractProducts/automationIntervalsControl.vue"
      ),
    "cprod-cancellation-request": () =>
      import(
        "@/components/app/global/contractProducts/cProdCancellationRequest.vue"
      ),
    "cprod-auto-expire-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoExpireMsg.vue"),
    "cprod-auto-renew-msg": () =>
      import("@/components/app/global/contractProducts/cProdAutoRenewMsg.vue"),
    "cprod-client-label-input": () =>
      import(
        "@/components/app/global/contractProducts/cProdClientLabelInput.vue"
      ),
    "billable-entities-provider": () =>
      import("@/components/app/global/client/billableEntitiesProvider.vue"),
    "billable-entities": () =>
      import("@/components/app/global/client/billableEntities.vue"),
    "billable-entities-control": () =>
      import("@/components/app/global/client/billableEntitiesControl.vue")
  }
})
export default class ContractProductSettings extends Mixins(
  CProdInjectorMixin,
  Context,
  HasValidation,
  RequestPromises
) {
  // Map State

  public invoiceConsolidation!: IClient["invoice_consolidation_enabled"];

  // Props

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  public isProcessing = false;

  public form = {
    payment_days_term: 0,
    create_invoice_term: 0
  } as IContractProductSettingsForm;

  public automationIntervalsForm = {
    suspend_interval: 0,
    close_interval: 0,
    cancel_interval: 0
  } as any;

  public changeCompanyOrAddressForm = {
    company_id: 0,
    address_id: 0
  } as any;

  public invoiceConsolidationForm: Pick<
    IContractProduct,
    "invoice_consolidation_enabled"
  > = {
    invoice_consolidation_enabled: InvoiceConsolidationTypes.DISABLED
  };

  public cprodForm: Pick<IContractProduct, "client_label"> = {
    client_label: ""
  };

  public formClone: IContractProductSettingsForm = {} as IContractProductSettingsForm;
  public invoiceConsolidationFormClone = {} as Pick<
    IContractProduct,
    "invoice_consolidation_enabled"
  >;
  public automationIntervalsFormClone = {};
  public changeCompanyOrAddressFormClone = {};
  public cprodFormClone = {} as Pick<IContractProduct, "client_label">;

  public mounted() {
    if (!this.cProdData.canModifySettings) this.routeToOverview();
  }

  public async created() {
    this.form = _.pick(this.cProdData.contractProduct, [
      "payment_days_term",
      "create_invoice_term",
      "client_label"
    ]);

    this.automationIntervalsForm = _.pick(this.cProdData.contractProduct, [
      "suspend_interval",
      "cancel_interval",
      "close_interval"
    ]);

    if (!this.isInvoiceExcluded) {
      this.invoiceConsolidationForm = _.pick(this.cProdData.contractProduct, [
        "invoice_consolidation_enabled"
      ]);
    }

    this.cprodForm = _.pick(this.cProdData.contractProduct, ["client_label"]);

    this.setCompanyOrAddressForm();

    this.formClone = _.clone(this.form);
    this.cprodFormClone = _.clone(this.cprodForm);
    this.automationIntervalsFormClone = _.clone(this.automationIntervalsForm);
    this.invoiceConsolidationFormClone = _.clone(this.invoiceConsolidationForm);
  }

  // Getters

  public openChangePaymentMethodModal() {
    this.$cProdMethods.openChangePaymentMethodModal({ parent: this });
  }

  public revertToInitialState() {
    this.form = _.clone(this.formClone);
    this.cprodForm = _.clone(this.cprodFormClone);
    this.automationIntervalsForm = _.clone(this.automationIntervalsFormClone);
    this.invoiceConsolidationForm = _.clone(this.invoiceConsolidationFormClone);

    this.changeCompanyOrAddressForm = _.clone(
      this.changeCompanyOrAddressFormClone
    );
  }

  public setCompanyOrAddressForm() {
    this.changeCompanyOrAddressForm = _.pick(this.cProdData.contract, [
      "company_id",
      "address_id"
    ]);
    this.changeCompanyOrAddressFormClone = _.clone(
      this.changeCompanyOrAddressForm
    );
  }

  public async refreshContract() {
    await this.$cProdMethods.reloadData();
    this.setCompanyOrAddressForm();
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(async result => {
        const promises: any = [];
        if (result) {
          if (this.hasChangedAutomationIntervals && this.isAdmin)
            promises.push(this.updateAutomationIntervals());
          if (this.hasChange && this.isAdmin)
            promises.push(this.updateCProdTerms());
          if (this.hasChangedCompanyOrAddress)
            promises.push(this.updateCompanyOrAddress());
          if (this.hasChangedInvoiceConsolidation)
            promises.push(
              this.$cProdMethods.updateInvoiceConsolidation(
                this.invoiceConsolidationForm
              )
            );
          if (this.hasCProdChange) promises.push(this.updateCProd());
          return Promise.all(promises);
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$cProdMethods.reloadData();
        this.$buefy.toast.open({
          message: this.$t("_.object_successfully_updated", {
            object: this.$t("_.contract")
          }) as string
        });

        // Clone forms again
        this.formClone = _.clone(this.form);
        this.cprodFormClone = _.clone(this.cprodForm);
        this.automationIntervalsFormClone = _.clone(
          this.automationIntervalsForm
        );
        this.changeCompanyOrAddressFormClone = _.clone(
          this.changeCompanyOrAddressForm
        );
        this.invoiceConsolidationFormClone = _.clone(
          this.invoiceConsolidationForm
        );
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.isProcessing = false));
  }

  public get catalogueProductRoute(): Location {
    return {
      name: "adminCatalogueProductAutomation",
      params: {
        productId: this.cProdData.contractProduct.product_id
      }
    };
  }

  public get invoiceConsolidationOptions() {
    return [
      {
        value: InvoiceConsolidationTypes.ENABLED,
        leftLabel: this.$t("_sentence.invoice.include_when_consolidating")
      },
      {
        value: InvoiceConsolidationTypes.DISABLED,
        leftLabel: this.$t("_sentence.invoice.exclude_from_consolidation")
      }
    ];
  }

  public get invoiceConsolidationInheritValue() {
    return InvoiceConsolidationTypes.INHERIT;
  }

  public get formIsDisabled() {
    // Change || Check
    return (
      this.isProcessing ||
      (!this.hasChange &&
        !this.hasChangedAutomationIntervals &&
        !this.hasChangedCompanyOrAddress &&
        !this.hasChangedInvoiceConsolidation) ||
      this.hasErrors
    );
  }

  public get hasChangedAutomationIntervals() {
    return !_.isEqual(
      this.automationIntervalsForm,
      this.automationIntervalsFormClone
    );
  }

  public get hasChangedCompanyOrAddress() {
    return !_.isEqual(
      this.changeCompanyOrAddressForm,
      this.changeCompanyOrAddressFormClone
    );
  }

  public get hasChangedInvoiceConsolidation() {
    return !_.isEqual(
      this.invoiceConsolidationForm,
      this.invoiceConsolidationFormClone
    );
  }

  public get hasChange() {
    return !_.isEqual(this.form, this.formClone);
  }

  public get hasCProdChange() {
    return !_.isEqual(this.cprodForm, this.cprodFormClone);
  }

  public get showInvoiceConsolidationSection() {
    const clientEnabled = this.$clientProvider().client
      .invoice_consolidation_enabled;

    return (
      clientEnabled === InvoiceConsolidationTypes.ENABLED ||
      (clientEnabled === InvoiceConsolidationTypes.INHERIT &&
        this.invoiceConsolidation)
    );
  }

  public get isInvoiceExcluded() {
    return !_.get(
      this.cProdData,
      "contractProduct.product.invoice_consolidation_enabled",
      false
    );
  }

  public updateCProdTerms() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/updateTerms`,
      {
        contractId: this.cProdData.contractId,
        contractProductId: this.cProdData.contractProduct.id,
        data: this.form
      }
    );
  }

  public updateAutomationIntervals() {
    return this.$cProdMethods.changeDates(
      this.automationIntervalsForm,
      () => ({})
    );
  }

  public updateCompanyOrAddress() {
    if (!this.hasChangedCompanyOrAddress) return;
    return this.$cProdMethods.changeAddressOrCompany(
      this.changeCompanyOrAddressForm
    );
  }

  public updateCProd() {
    if (!this.hasCProdChange) return;
    return this.$cProdMethods.update(this.cprodForm);
  }

  public onAddressSelect(address) {
    this.$set(this.changeCompanyOrAddressForm, "address_id", address.id);
    this.$set(this.changeCompanyOrAddressForm, "company_id", null);
  }

  public onCompanySelect(company) {
    if (company.id === this.changeCompanyOrAddressForm.company_id) return;

    this.$set(this.changeCompanyOrAddressForm, "company_id", company.id);
    this.$set(
      this.changeCompanyOrAddressForm,
      "address_id",
      company.address_id
    );
  }
}
